import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'
import imageBanner from './img/banner.png'
import imageTable from './img/table.jpg'

export const rpc3s125: ProductProps = {
  tag: ProductTag.ESS,
  category: ProductCategory.CommercialEnergyStorageSystems,
  pathName: 'rpc3-s125',
  banner: imageBanner,
  title: 'RPC3-S125',
  description: 'Peak shaving and valley filling,\nDynamic capacity increase,Demand control, Backup power supply',
  features: [
    {
      type: 'card-list',
      content: [
        {
          icon: 'deployment',
          title: 'Flexible deployment',
          description: [
            'Integrated design, seamless parallel connection of multiple machines, pre-installation and predebugging:IP54 protection level,meeting various outdoor scenarios:',
          ],
        },
        {
          icon: 'reliable',
          title: 'Safe and reliable',
          description: [
            'High and low temperature protection, over ad under voltage protection, short circuit protection, thermal runaway alarm and fire protection, anti-reverse flow, anti-overload, anti-islanding, and other multiple protections;',
          ],
        },
        {
          icon: 'intelligent',
          title: 'Intelligent operation and maintenance',
          description: [
            'Cloud-edge collaboration technology enables remote intelligent monitoring and local monitoring; improving the efficiency of full life cycle management of power stations;',
          ],
        },
        {
          icon: 'thermal',
          title: 'Efficient thermal management',
          description: [
            'Adopting a high-efficiency liquid cooling control system,the cell temperature difference is kept within 2°C;',
          ],
        },
        {
          icon: 'completeCertification',
          title: 'Complete certification',
          description: [
            'Comply with international certifications such as UL9540、UL9540A、UL1973、UL1741、UN38.3、FCC、CEC、IEC62619、IEC61000',
          ],
        },
      ],
    },
  ],
  specImages: [imageTable],
}
